module.exports = __webpack_public_path__ + "assets/img/block-e93381d4.png";